import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateProjectSchema } from "@/v2/schema/project";
import { Project } from "@/v2/types";

export default async function CreateProject(
    data: CreateProjectSchema,
): Promise<Project> {
    const res = await apiClientWithRefreshToken({
        url: "/projects",
        method: "POST",
        data: data,
    });

    return res.data;
}
